import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'

export const DeprecationDialog: React.FC = () => {
  const [open, setOpen] = React.useState(true)
  const css = useStyles()

  const handleDismiss = () => {
    setOpen(false)
  }

  const handleNavigate = () => {
    window.location.href = 'https://app.remote.it'
  }

  return (
    <Dialog
      open={open}
      onClose={handleDismiss}
      aria-labelledby="deprecation-dialog-title"
      aria-describedby="deprecation-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="deprecation-dialog-title" className={css.title}>
        Legacy Portal Will Be Taken Down on June 1, 2026
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="deprecation-dialog-description" className={css.body}>
          This legacy portal is now deprecated and will be taken down on
          June 1, 2026. All features are available at{' '}
          <a href="https://app.remote.it" className={css.link}>
            app.remote.it
          </a>
          . Please switch over now to avoid losing access.
        </DialogContentText>
      </DialogContent>
      <DialogActions className={css.actions}>
        <Button onClick={handleDismiss} color="default">
          Continue to legacy portal
        </Button>
        <Button onClick={handleNavigate} color="primary" variant="contained" autoFocus>
          Go to app.remote.it
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles({
  title: {
    '& h2': {
      fontWeight: 600,
    },
  },
  body: {
    fontSize: 15,
    lineHeight: 1.7,
  },
  link: {
    color: '#0096e7',
    textDecoration: 'none',
    fontWeight: 600,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  actions: {
    padding: '8px 24px 16px',
  },
})
